import { TermsComponent } from './_shared/components/terms/terms.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { LandingPageComponent } from './landing/landing.component';
import { AccountComponent } from './account/account.component';
import { AuthGuard } from './guards/auth.guard';
import { SettingsComponent } from './settings/settings.component';
import { SubscriptionComponent } from './settings/subscription/subscription.component';
import { ProfileCreationBackgroundComponent } from '../components/profile-creation-background/profile-creation-background.component';
import { RoleGuard } from './guards/role.guard';
import { SYSTEM_ROLES } from './_shared/enums';
import { CompanyRegisterInfoComponent } from './company-register-info/company-register-info.component';
import { AltiusLifeDomainGuard } from './guards/altiuslifeDomain.guard';
import { InsightsDomainGuard } from './guards/insightsDomain.guard';
import { InsightsDomainOnlyGuard } from './guards/insightsDomainOnly.guard';
import { QRComponent } from './qr/qr.component';
import { RequestAccessPageComponent } from './insights/request-access-page/request-access-page.component';
import { WelcomeComponent } from './insights/welcome/welcome.component';
import { DashboardComponent } from './insights/dashboard/dashboard.component';

const appRoutes: Routes = [
  { path: '', component: LandingPageComponent },
  { path: 'qr', component: QRComponent },
  {
    path: 'company-register-info',
    canActivate: [AltiusLifeDomainGuard],
    component: CompanyRegisterInfoComponent,
  },
  {
    path: 'home',
    canActivate: [AltiusLifeDomainGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'page',
    canActivate: [AltiusLifeDomainGuard],
    loadChildren: () => import('./page/page.module').then(m => m.PageModule),
  },
  {
    path: 'profile',
    component: AccountComponent,
    canActivate: [AuthGuard, AltiusLifeDomainGuard],
  },
  {
    path: 'bookmarks',
    loadChildren: () => import('./bookmarks/bookmarks.module').then(m => m.BookmarksModule),
    canActivate: [AuthGuard, AltiusLifeDomainGuard],
  },
  {
    path: 'notifications',
    canActivate: [AltiusLifeDomainGuard],
    loadChildren: () => import('./notifications/notifications.module').then(m => m.NotificationsModule),
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AltiusLifeDomainGuard],
    data: { breadcrumb: 'Settings', featureId: 83 },
    children: [
      {
        path: 'subscription',
        component: SubscriptionComponent,
        canActivate: [AuthGuard, AltiusLifeDomainGuard],
        data: { breadcrumb: 'Subscription', featureId: 15 },
      },
    ],
  },
  {
    path: 'share',
    canActivate: [AltiusLifeDomainGuard],
    loadChildren: () => import('./share/share.module').then(m => m.ShareModule),
  },
  {
    path: 'act',
    canActivate: [AltiusLifeDomainGuard],
    loadChildren: () => import('./act/act.module').then(m => m.ActModule),
  },
  {
    path: 'reward',
    canActivate: [AltiusLifeDomainGuard],
    loadChildren: () => import('./reward/reward.module').then(m => m.RewardModule),
  },
  {
    path: 'create',
    canActivate: [AuthGuard],
    component: ProfileCreationBackgroundComponent,
  },
  {
    path: 'toolkit',
    canActivate: [AltiusLifeDomainGuard],
    loadChildren: () => import('./toolkit/toolkit.module').then(m => m.ToolkitModule),
  },
  {
    path: 'competition',
    loadChildren: () => import('./questionnaires/questionnaires.module').then(m => m.QuestionnairesModule),
    canActivate: [AuthGuard, AltiusLifeDomainGuard],
  },
  {
    path: 'discover',
    canActivate: [AltiusLifeDomainGuard],
    loadChildren: () => import('./discover/discover.module').then(m => m.DiscoverModule),
  },
  {
    path: 'learn',
    canActivate: [AltiusLifeDomainGuard],
    loadChildren: () => import('./learn/learn.module').then(m => m.LearnModule),
  },
  {
    path: 'cms',
    loadChildren: () => import('./cms/cms.module').then(m => m.CmsModule),
    canActivate: [RoleGuard, AltiusLifeDomainGuard],
    data: {
      breadcrumb: 'Content Management System',
      roles: [SYSTEM_ROLES.ADMIN, SYSTEM_ROLES.SUPER_ADMIN, SYSTEM_ROLES.COORDINATOR],
    },
  },
  {
    path: 'terms-conditions',
    component: TermsComponent,
    data: { breadcrumb: 'Terms' },
  },
  {
    path: 'request-access',
    canActivate: [AuthGuard, InsightsDomainOnlyGuard],
    component: RequestAccessPageComponent,
  },
  {
    path: 'insights',
    canActivate: [AuthGuard, InsightsDomainGuard],
    component: WelcomeComponent,
  },
  {
    path: 'insights/dashboard/:id',
    canActivate: [AuthGuard, InsightsDomainGuard],
    component: DashboardComponent,
  },
  { path: '**', redirectTo: '/home' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes),
  ],
  exports: [
    RouterModule,
  ],
})
export class AppRoutingModule {
}
